import {
  resolveProgressStatus,
  isError,
  isLoaded
} from '../../lib/progressStatus'

// Action Types
export const Types = {
  RESET: 'OPERACIONAIS_THEME/RESET',
  SET_S3_PATH: 'OPERACIONAIS_THEME/SET_S3_PATH',
  SET_ERROR: 'OPERACIONAIS_THEME/SET_ERROR'
}

// Reducer
const initialState = {
  s3Path: undefined,
  error: false,
  loaded: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Types.SET_S3_PATH: {
      const status = resolveProgressStatus(action.payload)

      return {
        ...state,
        s3Path: action.payload,
        loaded: isLoaded(status),
        error: isError(status)
      }
    }
    case Types.SET_ERROR:
      return { ...state, error: action.payload, loaded: true }
    case Types.RESET:
      return initialState
    default:
      return state
  }
}

// Action Creators
export function setErrorOperacionais (data) {
  return {
    type: Types.SET_ERROR,
    payload: data
  }
}

export function setS3PathOperacionais (data) {
  return {
    type: Types.SET_S3_PATH,
    payload: data
  }
}

export function resetOperacionaisTheme () {
  return {
    type: Types.RESET
  }
}
